module.exports = __webpack_public_path__ + "img/LogoSinTextoIncidentes.c4753a2e.png";